import { branchActionType } from '../actions/branchAction';

const initialState = {
    branches: [],
    isLoading: false,
    error: null,
};

const branchReducer = (state = initialState, action) => {
    switch (action.type) {
        case branchActionType.FETCH_BRANCHES:
            return { 
                ...state, 
                branches: Array.isArray(action.payload) ? action.payload : action.payload?.data || [],
                isLoading: false,
                error: null
            };
        case branchActionType.ADD_BRANCH:
            return { 
                ...state, 
                branches: [...(state.branches || []), action.payload],
                isLoading: false,
                error: null
            };
        default:
            return state;
    }
};

export default branchReducer;
